// removed by extract-text-webpack-plugin
module.exports = {"label":"_2O1emdg","count":"_3_Y4sZZ","bold":"_179bjqa","button":"_1kpn9KI"};


//////////////////
// WEBPACK FOOTER
// ./template/components/SearchDropdown/ResultItem/index.css
// module id = ./template/components/SearchDropdown/ResultItem/index.css
// module chunks = client.sitechrome